// Bundles TaskItemBase hook setup to keep the render component under complexity limits
import { useTaskItemBaseSetup } from './useTaskItemBaseController.setup';

export function useTaskItemBaseController(props) {
  return useTaskItemBaseSetup(props);
}
